import { render, staticRenderFns } from "./Doge.vue?vue&type=template&id=618773aa&scoped=true&"
var script = {}
import style0 from "./Doge.vue?vue&type=style&index=0&id=618773aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618773aa",
  null
  
)

export default component.exports